import toast from "react-hot-toast";
import config, { API_CALL_TIMEOUT, API_URL, OPEN_ORDER_STATUS_LIST, PREVIOUS_ORDER_STATUS_LIST } from "../Config/config";
const CryptoJS = require("crypto-js");
import axios from "axios";
import errorMsg from "../Fixures/errorMessages.json"

export const fetchApiData = async (url, options, preventTimeout) => {
	// let auth = localStorage.getItem("ORDER_AUTH_TOKEN");
	let auth = getLocalStorageItem("ORDER_AUTH_TOKEN");

	if (auth) {
		options["headers"]["authToken"] = auth;
	}

	return new Promise((resolve, reject) => {

		const axiosOptions = {
			method: options.method,
			url: url,
			data: options.body ? options.body : {},
			headers: options.headers,
			params: options.params ? options.params : {}
		};
		if (!preventTimeout) {
			// axiosOptions.timeout = API_CALL_TIMEOUT;
		}

		axios(axiosOptions)
			.then((response) => {

				let data = response.data;
				if (data.code === 401) {
					displayLog("error", errorMsg.notification.user.session.expired);
					// logOut(false);
				} else {
					resolve(data);
				}
			})
			.catch(async (error) => {
				// console.log("ERROR: ", error);
				if (error && error.response && error.response.status === 401) {
					displayLog("error", errorMsg.notification.user.session.expired);
				}

				if (error && error.response && error.response.status === 500) {
					resolve(error.response.data);
				}

				resolve(error.response?.data);
			});
	});
};

export const storeLocalStorage = (name, value) => {
	let storageData = getLocalStorage(name);
	if (storageData) {
		let parsedStorageData = JSON.parse(storageData);
		let mergeData = { ...parsedStorageData, ...value };
		window.localStorage.setItem(name, JSON.stringify(mergeData));
		return;
	}
	window.localStorage.setItem(name, JSON.stringify(value));
	return;
};

export const getLocalStorage = (name, value) => {
	return window.localStorage.getItem(name);
};

export const getFullName = (first, last) => {
	const firstName = (first || "");
	const lastName = (last || "");
	const fullName = `${firstName} ${lastName}`;

	return fullName;
};

export const getLabelColor = (label) => {
	if (label == "New") {
		return <span className={`notify_status new`}></span>;
	} else if (label == "Awarded" || label == "Pending Seller Confirmation (Awarded)") {
		return <span className={`notify_status awarded`}></span>;
	} else if (label == "Confirmed" || label == "Delivered") {
		return <span className={`notify_status confirmed`}></span>;
	} else if (label == "Pending" || label == "Bid Submitted") {
		return <span className={`notify_status pending`}></span>;
	} else if (label == "cancelled" || label == "Bid Rejected") {
		return <span className={`notify_status cancelled`}></span>;
	} else if (label == "Delivery Scheduled") {
		return <span className={`notify_status delivery-scheduled`}></span>;
	} else if (label == "Delivery In Progress") {
		return <span className={`notify_status delivery-in-progress`}></span>;
	} else {
		return <span className={`notify_status`}></span>;
	}
};

export const getBadge = (label) => {

	return label;
	if (label == "New") {
		return (
			<label className={`ls-1`} title={label}>
				{label}
			</label>
		);
	} else if (label == "Awarded" || label == "Pending Seller Confirmation (Awarded)") {
		return (
			<label className={`ls-1`} title={label}>
				{"Awarded"}
			</label>
		);
	} else if (label == "Confirmed" || label == "Delivered") {
		return (
			<label className={` ls-1`} title={label}>
				{label}
			</label>
		);
	} else if (label == "Pending" || label == "Bid Submitted") {
		return (
			<label className={`ls-1`} title={label}>
				{label}
			</label>
		);
	} else if (label == "cancelled" || label == "Bid Rejected") {
		return (
			<label className={`ls-1`} title={label}>
				{label}
			</label>
		);
	} else if (label == "Delivery Scheduled") {
		return (
			<label className={`ls-1`} title={label}>
				{label}
			</label>
		);
	} else if (label == "Delivery In Progress") {
		return (
			<label className={`ls-1`} title={label}>
				{label}
			</label>
		);
	} else {
		return <span className={`text-dark`}>{label}</span>;
	}
};

export const calculate = (gallons, prices) => {
	let obj = {
		bidPrice: prices?.bidPricePerGallon ? prices?.bidPricePerGallon : "...",
		subTotal: prices?.bidPricePerGallon ? (gallons * prices?.bidPricePerGallon).toFixed(2) : "...",
		freightCharge: prices?.perMilePrice && prices?.freightCharges ? (prices.freightCharges * prices.perMilePrice).toFixed(2) : "...",
		fedLustTax: Number(gallons) ? (0.184 * Number(gallons)).toFixed(2) : "...",
		exiceTax: Number(gallons) ? (0.515 * Number(gallons)).toFixed(2) : "...",
		otherFees: Number(gallons) ? (0.184 * Number(gallons)).toFixed(2) : "...",
		grandTotal: "...",
	};

	obj["grandTotal"] = Number(obj?.subTotal) ? (Number(obj?.subTotal) + Number(obj?.freightCharge) + Number(obj?.fedLustTax) + Number(obj?.exiceTax) + Number(obj?.otherFees)).toFixed(2) : 0;

	return obj;
};

/**
 * Displays a toast notification using the provided parameters.
 *
 * @param {"success" | "error" | string} type - The type of the toast notification ('success', 'error', or any other string).
 * @param {string} text - The text content of the toast notification.
 * @param {Object} [_otherOptions] - Additional options for configuring the toast notification (optional).
 * @param {string} [_otherOptions.position='top-center'] - The position where the toast notification will be displayed (default is 'top-center').
 *
 * @example
 * // Display a success toast
 * displayLog('success', 'Operation successful');
 *
 * // Display an error toast with custom options
 * displayLog('error', 'Error occurred', { position: 'bottom-right' });
 *
 * // Display a custom type toast
 * displayLog('info', 'Custom message', { position: 'top-left' });
 */
export const displayLog = (type, text, _otherOptions) => {
	let options = {
		position: "top-center",
	};
	if (_otherOptions) options = { ...options, ..._otherOptions };

	if (type == "success") {
		toast.success(text, options);
	} else if (type == "error") {
		toast.error(text, options);
	} else {
		toast(text, options);
	}
};

export const handleNotificationRedirection = (type, id) => {
	const ROLE = localStorage.getItem("ORDER_USER_ROLE");

	switch (type) {
		// Seller redirections
		case "bids": {
			return "/bids/" + id;
		}

		case "prevorders": {
			return "/prevorders/" + id;
		}

		case "openorders": {
			return "/openorders/" + id;
		}

		// Logistic redirections
		case "open-orders": {
			if (ROLE == config.ROLE_SELLER) {
				return "/openorders/" + id;
			} else {
				return "/open-orders/" + id;
			}
		}

		case "orders-in-progress": {
			return "/orders-in-progress/" + id;
		}

		case "orders-in-progress/track": {
			return "/orders-in-progress/track/" + id;
		}

		case "drivers/edit": {
			return "/drivers/edit/" + id;
		}

		case "open_orders/order_details": {
			return "/open-orders/" + id;
		}

		default:
			return "/notifications";
	}
};

export const getCountries = async () => {
	let response = await fetchApiData(`${API_URL}/auth/countryCode`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	});

	// if (response && !response.error) {
	if (response && response.data) {
		const arrayOfObj = Object.entries(response.data).map((e) => ({ ...e[1] }));
		return arrayOfObj;
	} else {
		return [];
	}
};

export const handlePrivacyAndTermsNavigation = (path) => {
	window.open(path, "_blank");
};

export const getCurrentLocation = async () => {
	let location = {
		lat: "",
		lng: "",
	};

	const currentLocation = window.navigator && window.navigator.geolocation;

	if (currentLocation) {
		return new Promise((resolve, reject) => {
			currentLocation.getCurrentPosition(
				(position) => {
					location.lat = position.coords.latitude;
					location.lng = position.coords.longitude;
					resolve(location);
				},
				(error) => {
					resolve(location);
				}
			);
		});
	}
};

export const getRedirectionRouteBasedOnOrderStatus = (type, id) => {
	const ROLE = localStorage.getItem("ORDER_USER_ROLE");

	if (OPEN_ORDER_STATUS_LIST.includes(type)) {
		return "/openorders/" + id;
	}

	if (PREVIOUS_ORDER_STATUS_LIST.includes(type)) {
		return "/prevorders/" + id;
	}

	return "";
};

export const getZipCodeDetails = async (zipCode) => {
	let response = await fetchApiData(`${API_URL}/auth/detailByZip`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			zipCode,
		}),
	});

	if (response && !response.error) {
		return response.data;
	} else {
		return null;
	}
};

export const sortResponse = async (array, keyToSortBy, asc) => {
	array.sort(function (a, b) {
		if (a[keyToSortBy] < b[keyToSortBy]) return -1;
		if (a[keyToSortBy] > b[keyToSortBy]) return 1;
		return 0;
	});

	return array;
};

export const setLocalStorageItem = (key, value) => {
	const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(value), config.SECRET_KEY);
	localStorage.setItem(key, encryptedData);
};

export const getLocalStorageItem = (key) => {
	try {
		const encryptedData = localStorage.getItem(key);
		const bytes = CryptoJS.AES.decrypt(encryptedData.toString(), config.SECRET_KEY);
		const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
		return decryptedData;
	} catch {
		return null;
	}
};

export const encrypt = (value) => {
	const encryptedData = CryptoJS.AES.encrypt(value, config.SECRET_KEY).toString();
	return encryptedData;
};

export const decrypt = (encryptedData) => {
	const bytes = CryptoJS.AES.decrypt(encryptedData.toString(), config.SECRET_KEY);
	const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
	return decryptedData;
};

export const clearLocalStorage = () => localStorage.clear();

export const getLoggedInUserDetails = () => {
	let userdetails = getLocalStorageItem("user_details");
	return userdetails;
};


export const handleZipChange = async (zip) => {

	if (zip && zip.length) {
		const response = await getZipCodeDetails(zip);

		if (response && response._id) {
			return response;
		}
		return null;
	}
};

/**
 * 
 * @param {string|number} input 
 * @returns 
 */
export function formatNumberWithCommas(input) {
	const str = String(input);

	if (!/^\d+(\.\d+)?$/.test(str)) {
		return "";
	}

	const parts = str.split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

	return parts.join(".");
}